import {Cureus} from '../Cureus';

Cureus.NewsroomPosts = {};

//= require_tree ./NewsroomPosts